__turbopack_context__.v({
  "className": "drg62a_className",
  "variable": "drg62a_variable",
});
